/**
 * @generated SignedSource<<3948c33224a9098fdd903b43ebc0f554>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TitleEditModeBlockData$data = {
  readonly content: string;
  readonly " $fragmentType": "TitleEditModeBlockData";
};
export type TitleEditModeBlockData$key = {
  readonly " $data"?: TitleEditModeBlockData$data;
  readonly " $fragmentSpreads": FragmentRefs<"TitleEditModeBlockData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleEditModeBlockData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "TitleBlock",
  "abstractKey": null
};

(node as any).hash = "6087da66441d6fe6f0132fa0593efe9a";

export default node;
